import { useAppShellPush } from 'AppShell/RoutingHelper';
import { UseLocationChangeReturnType } from 'Interfaces/UseLocationChangeReturnType';

export function useLocationChange(): UseLocationChangeReturnType {
    const locationChange = useAppShellPush();

    return {
        locationChange,
    };
}

export default useLocationChange;
